import { Record, List } from 'immutable';
import ErrorRecord from '~/data/ErrorRecord';
import LegalDocumentRecord from '~/data/LegalDocumentRecord';

const keys: Fields = {
  isLoading: false,
  imprintDocuments: List(),
  privacyNoticeDocuments: List(),
  termsAndConditionsDocuments: List(),
  cookiePolicyDocuments: List(),
  paymentTermsDocuments: List(),
  dataProcessingDocuments: List(),
  personalInformationSharingPolicies: List(),
  error: undefined,
};

interface Fields {
  isLoading: boolean;
  imprintDocuments: List<LegalDocumentRecord>;
  privacyNoticeDocuments: List<LegalDocumentRecord>;
  termsAndConditionsDocuments: List<LegalDocumentRecord>;
  cookiePolicyDocuments: List<LegalDocumentRecord>;
  paymentTermsDocuments: List<LegalDocumentRecord>;
  dataProcessingDocuments: List<LegalDocumentRecord>;
  personalInformationSharingPolicies: List<LegalDocumentRecord>;
  error?: ErrorRecord;
}

export default class LegalDocumentsRecord extends Record<Fields>(keys) {
  setDocuments(
    imprintDocuments,
    privacyNoticeDocuments,
    termsAndConditionsDocuments,
    cookiePolicyDocuments,
    paymentTermsDocuments,
    dataProcessingDocuments,
    personalInformationSharingPolicies
  ) {
    return this.merge({
      imprintDocuments: List(
        imprintDocuments.map((imprintDocument) => new LegalDocumentRecord(imprintDocument))
      ),
      privacyNoticeDocuments: List(
        privacyNoticeDocuments.map(
          (privacyNoticeDocument) => new LegalDocumentRecord(privacyNoticeDocument)
        )
      ),
      termsAndConditionsDocuments: List(
        termsAndConditionsDocuments.map(
          (termsAndConditionsDocument) => new LegalDocumentRecord(termsAndConditionsDocument)
        )
      ),
      cookiePolicyDocuments: List(
        cookiePolicyDocuments.map(
          (cookiePolicyDocument) => new LegalDocumentRecord(cookiePolicyDocument)
        )
      ),
      paymentTermsDocuments: List(
        paymentTermsDocuments.map(
          (paymentTermsDocument) => new LegalDocumentRecord(paymentTermsDocument)
        )
      ),
      dataProcessingDocuments: List(
        dataProcessingDocuments.map(
          (dataProcessingDocument) => new LegalDocumentRecord(dataProcessingDocument)
        )
      ),
      personalInformationSharingPolicies: List(
        personalInformationSharingPolicies.map(
          (personalInformationSharingPolicy) =>
            new LegalDocumentRecord(personalInformationSharingPolicy)
        )
      ),
    });
  }
}
